module.exports = __webpack_public_path__ + "static/media/volodin.ac2ba3c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/volodin.png
// module id = 365
// module chunks = 0